import React, { useEffect, useState } from "react";
import { Container, Box, Typography, Button } from "@mui/material";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore as db } from "../../firebase";
import AdvancedChecklistForm from "./AdvancedChecklistForm";

export default function AdvancedAdminChecklist() {
  const [checklists, setChecklists] = useState([]);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "amc_checklists"), (snap) => {
      setChecklists(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  return (
    <Container>
      <Box
        sx={{
          my: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4">AMC Advanced - Admin</Typography>
        <Button variant="contained" onClick={() => setShowForm((s) => !s)}>
          {showForm ? "Close" : "+ Create"}
        </Button>
      </Box>

      {showForm && <AdvancedChecklistForm onSaved={() => setShowForm(false)} />}

      <Box sx={{ mt: 2 }}>
        {checklists.map((c) => (
          <Box key={c.id} sx={{ mb: 2, p: 2, border: "1px solid #eee" }}>
            <Typography variant="h6">{c.title}</Typography>
            <Typography variant="body2">{c.description}</Typography>
            {c.media && c.media.length > 0 && (
              <Box sx={{ mt: 1 }}>
                {c.media.map((m) => (
                  <Box key={m.path} sx={{ mb: 1 }}>
                    {m.type.startsWith("image/") && (
                      <img src={m.url} alt={m.name} style={{ maxWidth: 220 }} />
                    )}
                    {m.type.startsWith("audio/") && (
                      <audio controls src={m.url} />
                    )}
                    {m.type.startsWith("video/") && (
                      <video controls src={m.url} style={{ maxWidth: 320 }} />
                    )}
                    <Typography variant="caption">{m.name}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
}
